import { DATE_FORMAT_HM, formatDateStringToString } from "@/utils";
import moment from "moment";
import Vue from "vue";
import { mapState } from "vuex";
import {
  DATE_FORMAT_FULL,
  DATE_FORMAT_SHORT,
  DURATION_TYPES,
  EXPLANATION_REFUND_BY_HOUR,
  FOLDER_NAME_LEAVE_REQUEST,
  REQUEST_TYPE_HOUR,
  REQUEST_TYPE_SHIFT,
  TIME_STAFF,
} from "../../../components/commons/commonConstant";
import {
  checkShowWithLastTimesheet,
  convertAvatarName,
  getInfoStaff,
  getMessages,
  getStatusTimeSheet,
} from "../../../components/commons/commons";
import RequestModal from "../../../components/RequestManagement/RequestModal.vue";
import StaffTimesheetDetail from "../StaffTimesheetDetail/StaffTimesheetDetail.vue";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("formatMonth", function (value) {
  if (value) {
    return moment(String(value)).format("MM/YYYY");
  }
});

export default {
  name: "timesheet-View-staff",
  props: ["timesheetUser", "timesheetInfo", "getTimesheetDetail"],
  components: {
    StaffTimesheetDetail,
    RequestModal,
  },
  data() {
    return {
      rowsTable: [],
      dataSource: {},
      getInfoStaff,
      DURATION_TYPES,
      columnsTableDetailOfDays: [
        {
          title: "No",
          dataIndex: "no",
          width: 50,
          render: (row, data, index) => {
            return index + 1;
          },
        },
        {
          title: "Date",
          dataIndex: "date_of_issue",
          // scopedSlots: { customRender: 'date' },
          render: (row) => {
            return row.value;
          },
        },
        {
          title: "Shift",
          dataIndex: "workSchedule",
          width: 200,
          render: (_, data) => {
            if (!data) return "";
            const { jobInfoHistoryNestedDTO } = data;
            if (!jobInfoHistoryNestedDTO) return "";
            const { workSchedule, rule_type_name_vi } = jobInfoHistoryNestedDTO;
            return `${rule_type_name_vi ?? ""} ${formatDateStringToString(
              workSchedule?.work_start_time,
              DATE_FORMAT_HM
            )} - ${formatDateStringToString(workSchedule?.work_end_time, DATE_FORMAT_HM)}`;
          },
        },
        {
          title: "Checkin time",
          dataIndex: "check_in_time",
          render: (_, data) => {
            return data && data.check_in_time ? this.formatTime(data.check_in_time) : "";
          },
        },
        {
          title: "Checkout time",
          dataIndex: "check_out_time",
          render: (_, data) => {
            return data && data.check_out_time ? this.formatTime(data.check_out_time) : "";
          },
        },
        {
          title: "Working day",
          dataIndex: "value",
          width: 100,
        },
      ],
      columnsTableDetailOfDaysFlexible: [
        {
          title: "No",
          dataIndex: "no",
          width: 50,
          render: (_row, _data, index) => {
            return index + 1;
          },
        },
        {
          title: "Date",
          dataIndex: "date_of_issue",
          width: 200,
          render: (row) => {
            return row.value;
          },
        },
        {
          title: "Work schedule",
          dataIndex: "workSchedule",
          width: 200,
        },
        {
          title: "Checkin time",
          dataIndex: "check_in_time",
          width: 120,
          render: (_, data) => {
            return data && data.check_in_time ? this.formatTime(data.check_in_time) : "";
          },
        },
        {
          title: "Checkout time",
          dataIndex: "check_out_time",
          width: 120,
          render: (_, data) => {
            return data && data.check_out_time ? this.formatTime(data.check_out_time) : "";
          },
        },
        {
          title: "Working day",
          dataIndex: "value",
          width: 120,
        },
        {
          title: "Absent time (Min)",
          dataIndex: "absent_time",
          width: 150,
          render: (_, data) => {
            return data?.absent_time ? data?.absent_time : data?.value ? 0 : "";
          },
        },
        {
          title: "Request",
          dataIndex: "request",
          render: (_, data) => {
            return data?.request_detail ? data?.request_detail : [];
          },
          width: 100,
        },
        {
          title: "Action",
          dataIndex: "action",
          width: 200,
        },
      ],
      columns: [],
      tooltipTimesheet: {
        data: [
          { label: "Check in-out time", key: "checkInOut" },
          { label: "Request", key: "request" },
          { label: "Edited", key: "edited" },
          { label: "Editor", key: "editor" },
          { label: "Total Edited Time", key: "totalEditedTime" },
          { label: "Active Time", key: "activeTime" },
        ],
        config: {
          isVisible: false,
          x: 0,
          y: 0,
        },
      },

      detailMonthOfStaff: [
        {
          title: "Total working days",
          description: "Total working days",
          key: "total_working_days",
        },
        {
          title: "Total paid leave days",
          description: "Total paid leave days",
          key: "total_paid_leave_days",
        },
        {
          title: "Total paid benefits leave days",
          description: "Total paid benefits leave days",
          key: "total_paid_benefits_leave_days",
        },
        {
          title: "Birthday leave",
          description: "Birthday leave",
          key: "birthday_leave",
        },
        {
          title: "Total onsite days",
          description: "Total onsite days",
          key: "total_onsite_days",
        },
        {
          title: "Total public holidays",
          description: "Total public holidays",
          key: "total_public_holidays",
        },
        {
          title: "Total offset leave days",
          description: "Total offset leave days",
          key: "total_offset_leave_days",
        },
        {
          title: "Total leave days that social insurance covers",
          description: "Total leave days that social insurance covers",
          key: "total_days_off_social_insurance_covers",
        },
        {
          title: "Total unpaid leave days",
          description: "Total unpaid leave days",
          key: "total_unpaid_leave_days",
        },
        {
          title: "Total paid days",
          description: "Total paid days",
          key: "total_paid_days",
        },
        {
          title: "Total paid probationary days",
          description: "Total paid probationary days",
          key: "total_paid_probationary_days",
        },
        {
          title: "Total paid official days",
          description: "Total paid official days",
          key: "total_paid_official_days",
        },
        {
          title: "Total number of violations",
          description: "Total number of violations",
          key: "countDaysNotEnoughWorkingTime",
        },
      ],
      dayOffByStaff: [
        {
          title: "Total authorized leave days",
          description: "Total authorized leave days",
          key: "total_annual_leave",
        },
        {
          title: "Beginning of period",
          description: "Beginning of period",
          key: "annual_leave_beginning_of_period",
        },
        {
          title: "Used in period",
          description: "Số ngày phép dùng trong kì",
          key: "annual_leave_days_used_in_period",
        },
        {
          title: "End of period",
          description: "End of period",
          key: "remaining_paid_leave_days_of_year",
        },
      ],
      violationWorkingDay: [
        {
          title: "Approved late coming and early leaving",
          description: "Approved late coming and early leaving",
          key: "approved_late_coming_and_early_leaving",
        },
        {
          title: "Unapproved late coming and early leaving",
          description: "Unapproved late coming and early leaving",
          key: "unapproved_late_coming_and_early_leaving",
        },
        {
          title: "“Missed attendance-check” days counted as working days",
          description: "“Missed attendance-check” days counted as working days",
          key: "days_forget_taking_attendance_counted_as_working_day",
        },
        {
          title: "“Missed attendance-check” days counted as half working days",
          description: "“Missed attendance-check” days counted as half working days",
          key: "days_forget_taking_attendance_counted_as_half_working_day",
        },
        {
          title: "“Missed attendance-check” days counted as unpaid leave days",
          description: "“Missed attendance-check” days counted as unpaid leave days",
          key: "total_unpaid_leave_days",
        },
        {
          title: "Late coming, early leaving, “Missed attendance-check” days",
          description: "Late coming, early leaving, “Missed attendance-check” days",
          key: "daysNotEnoughWorkingTime",
        },
        {
          title: "Total number of violations",
          description: "Total number of violations",
          key: "countDaysNotEnoughWorkingTime",
        },
        {
          title: "Total number of violations exceed",
          description: "Total number of violations exceed",
          key: "total_number_of_violations_exceed",
        },
      ],
      annualLeave: [
        { label: "Total Annual Leave", key: "total_annual_leave" },
        { label: "Annual leave at the beginning of the period", key: "annual_leave_beginning_of_period" },
        { label: "Annual leave days used in the period", key: "annual_leave_days_used_in_period" },
        { label: "Remaining paid leave days of the year", key: "remaining_paid_leave_days_of_year" },
      ],
      infringeData: [
        {
          title: "Late coming, early leaving, “Missed attendance-check” days",
          description: "Late coming, early leaving, “Missed attendance-check” days",
          key: "daysNotEnoughWorkingTime",
        },
      ],
      colorAvatar: localStorage.getItem("color_avatar"),
      dataRequests: {},
      recordSelected: {},
      visibleModal: false,
      requestTypeDay: REQUEST_TYPE_HOUR,
      explanationTypeDay: EXPLANATION_REFUND_BY_HOUR,
      requestTypeLog: REQUEST_TYPE_HOUR,
      explanationTypeLog: EXPLANATION_REFUND_BY_HOUR,
      request_type: FOLDER_NAME_LEAVE_REQUEST,
      REQUEST_TYPE_HOUR,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      notesData: (state) => state.timesheet.noteList,
      calculationWorking: (state) => state.timesheet.calculationWorking,
      dataRequestSelections: (state) => state.request.dataRequestSelections,
      lastTimesheet: (state) => state.application.lastTimesheet,
      employeeList: (state) => state.application.employeeList,
      approverUser: (state) => state.application.approverUser,
      dataDurationTime: (state) => state.request.dataDurationTime,
      abnormalList: (state) => state.abnormalcase.abnormalList.data,
      dataActualFixed: (state) => state.abnormalcase.dataActualFixed,
      loading: (state) => state.user.loading,
      timeServer: (state) => state.application.timeServer,
    }),
    checkShiftHour() {
      const { requestType } = this.userInfo;
      return requestType === REQUEST_TYPE_HOUR;
    },
  },
  created() {
    this.$store.dispatch("request/getParamsDataToSelect", { screenType: "Request" });
    const { requestType, explanationType } = this.userInfo;
    this.requestTypeDay = requestType;
    this.requestTypeLog = requestType;
    this.explanationTypeDay = explanationType;
    this.explanationTypeLog = explanationType;
    this.getLastTimesheetInfo();
    this.columns =
      this.requestTypeDay === REQUEST_TYPE_HOUR ? this.columnsTableDetailOfDaysFlexible : this.columnsTableDetailOfDays;
    // Get Time Server
    this.$store.dispatch("application/getTimeServer");
  },
  mounted() {
    this.renderRowTable();
  },
  watch: {
    timesheetInfo: function (newVal, oldVal) {
      if (newVal.timesheet_id !== oldVal.timesheet_id) {
        this.renderRowTable();
      }
    },
    timesheetUser: function () {
      this.timesheetUser.timesheets.forEach((element) => {
        let key = moment(element.date_of_issue).format("YYYYMMDD");
        this.timesheetUser[key] = element;
      });
    },
    visibleModal() {
      if (!this.visibleModal) {
        this.dataRequests = {};
        this.requestTypeLog = this.requestTypeDay;
        this.explanationTypeLog = this.explanationTypeDay;
      }
    },
  },
  methods: {
    generateWorkschedule(data) {
      if (!data) return "";
      const { jobInfoHistoryNestedDTO } = data;
      if (!jobInfoHistoryNestedDTO) return "";
      const { workSchedule } = jobInfoHistoryNestedDTO;
      return workSchedule?.work_schedule_name_vi ?? "";
    },
    generateClassStatus(status) {
      switch (status) {
        case "Pending":
          return "request-info__status--pending";
        case "Approved":
          return "request-info__status--approved";
        case "Rejected":
          return "request-info__status--rejected";
        default:
          return "request-info__status--pending";
      }
    },
    getTimeSheetUser() {
      this.$store.dispatch("request/getParamsDataToSelect", {
        screenType: "Request",
      });
      this.$store.dispatch("user/loadingRequest");
      this.$store
        .dispatch("timesheet/getUserTimesheetFlexible", {
          employmentID: this.userInfo.userId,
          timesheetId: this.timesheetInfo.timesheet_id,
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
    },
    renderClass(value) {
      if (value === "1.0" || value === "1") {
        return "color-full";
      } else if (value && parseFloat(value) < 1.0) {
        return "color-lack";
      } else {
        return `color-${value}`;
      }
    },
    checkShowAction(data) {
      return (
        data &&
        data?.absent_time &&
        checkShowWithLastTimesheet(
          data.date_of_issue,
          this.lastTimesheet?.last_timesheet_period_end_date,
          TIME_STAFF,
          DATE_FORMAT_FULL,
          this.timeServer
        )
      );
    },
    renderRowTable() {
      let rows = [];
      let startDate = moment(this.timesheetInfo.from_date);
      let endDate = moment(this.timesheetInfo.to_date);
      while (startDate.isSameOrBefore(endDate)) {
        let day = moment(startDate).day();
        let className;
        className = day === 0 || day === 6 ? "bg-holiday" : "";
        rows.push({
          dataIndex: moment(startDate).format("YYYYMMDD"),
          class: className,
          key: moment(startDate).format("YYYYMMDD"),
          value: moment(startDate).format("DD/MM/YYYY"),
          //add here !!!!
        });
        startDate = startDate.add(1, "day");
      }
      this.rowsTable = rows;
    },
    getStatus() {
      return getStatusTimeSheet(this.timesheetInfo.status);
    },
    checkHoverTS(timesheet, history, data) {
      if (timesheet.history) {
        history = timesheet.history.history.reduce((a, b) => (a.modified_date > b.modified_date ? a : b));
        data.edited =
          history.old_value + " -> " + history.new_value + " (" + moment(history.modified_date).format("HH:mm") + ")";
        data.editor = history.modifier.name + " - " + history.modifier.department;
        data.totalEditedTime = timesheet.history.history.length;
      }
      if (timesheet.requests) {
        let request = "";
        timesheet.requests.forEach((req) => {
          request += req.request_type_name_en
            ? req.request_type_name_en
            : req.reason_type_name_vi + "&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp" + req.request_status + "<br/>";
        });
        data.request = request;
      }
    },
    handleHoverTimeSheet(event, timesheet) {
      event.preventDefault();
      if (timesheet && timesheet.value) {
        const widthScreen = window.innerWidth;
        const heightScreen = window.innerHeight;
        const widthTooltip = 350;
        const heightTooltip = document.getElementById("tooltip-timesheet").offsetHeight;
        const clientX = widthScreen < event.clientX + widthTooltip ? event.clientX - widthTooltip : event.clientX;
        const clientY = heightScreen < event.clientY + heightTooltip ? event.clientY - heightTooltip : event.clientY;
        this.tooltipTimesheet.config = {
          isVisible: true,
          x: clientX,
          y: clientY + 10,
          viewMode: "today",
        };
        let history = {};
        const checkIn = timesheet.check_in_time ? moment(timesheet.check_in_time).format("HH:mm") : null;
        const checkOut = timesheet.check_out_time ? moment(timesheet.check_out_time).format("HH:mm") : "No Data";
        const data = {
          checkInOut: checkIn === null && checkOut === null ? "No Data" : checkIn + " - " + checkOut,
        };
        this.checkHoverTS(timesheet, history, data);
        this.tooltipTimesheet.dataDetail = data;
      }
    },
    getAvatarName(fullName) {
      return convertAvatarName(fullName);
    },
    formatTime(dateTime) {
      if (dateTime && dateTime !== null && dateTime !== "" && moment(dateTime).format("HH:mm") !== "Invalid date") {
        return moment(dateTime).format("HH:mm");
      } else return null;
    },
    helper(data, type) {
      if (data) {
        if (type === "check-in") {
          return data.is_late_coming;
        } else if (type === "check-out") {
          return data.is_early_leaving;
        }
      }
      return false;
    },
    handleClickCreateRequest(e, record) {
      this.request_type = FOLDER_NAME_LEAVE_REQUEST;
      this.recordSelected = record;
      this.dateOfIssue = moment(record.date_of_issue, DATE_FORMAT_FULL);
      this.$store.dispatch("user/loadingRequest");
      this.$store
        .dispatch("application/getWorkScheduleUser", {
          userId: this.userInfo.userId,
          date: this.dateOfIssue.format(DATE_FORMAT_SHORT),
        })
        .then((res) => {
          if (res.requestType === REQUEST_TYPE_HOUR) {
            this.dataRequests = {
              index: Date.now(),
              requestDate: this.dateOfIssue,
              requestTypeLog: REQUEST_TYPE_HOUR,
              requestHours: [],
              isDisableDuration: true,
              duration: undefined,
              hour: undefined,
              minute: undefined,
              errorDate: "",
              errorHour: "",
              errorMinute: "",
            };
          } else {
            this.dataRequests = {
              index: Date.now(),
              requestDate: this.dateOfIssue,
              duration: undefined,
              requestTypeLog: REQUEST_TYPE_SHIFT,
              isDisableDuration: false,
              requestHours: [],
            };
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        })
        .finally(() => {
          this.visibleModal = true;
          this.$store.commit("user/RESET_LOADING");
        });
    },
    getLastTimesheetInfo() {
      this.$store
        .dispatch("application/getEndDateOfLastTimsheet")
        .then((res) => {
          getMessages(res);
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        });
    },

    handleCancel() {
      this.visibleModal = false;
      this.dataRequests = {};
    },
  },
};
